import gql from "graphql-tag";

const buildingPersonnelMutations = {


    createBuildingPersonnel: gql`
        mutation CreateBuildingPersonnel($building_id: Int, $manager_id: Int, $foreman_id: Int, $substitute_id: Int) {
            createBuildingPersonnel(building_id: $building_id, manager_id: $manager_id, foreman_id: $foreman_id, substitute_id: $substitute_id) {
                id,
                building_id,
                manager_id,
                foreman_id,
                substitute_id
            }
        }
    `,
    updateBuildingPersonnel: gql`
        mutation UpdateBuildingPersonnel($id: ID!, $building_id: Int, $manager_id: Int, $foreman_id: Int, $substitute_id: Int) {
            updateBuildingPersonnel(id: $id, building_id: $building_id, manager_id: $manager_id, foreman_id: $foreman_id, substitute_id: $substitute_id) {
                id,
                building_id,
                manager_id,
                foreman_id,
                substitute_id
            }
        }
    `,
};

export default buildingPersonnelMutations;